import { SelectInput } from '@interstate/components/SelectInput';
import { BalloonTermTypeInfo, useBalloonTermTypeField } from '@makemydeal/dr-dash-components';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { LabelWithInfo } from '../../../ScenarioGrid.style';
import { ScenarioRow } from '../../ScenarioRow';

export const BalloonTermTypeRow = () => {
    const { label, selectProps } = useBalloonTermTypeField();
    const inputId = useScenarioCellId('balloonTermType');

    return (
        <ScenarioRow
            rowKey="balloonTermType"
            label={
                <LabelWithInfo>
                    <label htmlFor={inputId}>{label}</label>
                    <BalloonTermTypeInfo />
                </LabelWithInfo>
            }
        >
            <SelectInput {...selectProps} id={inputId} label={label} />
        </ScenarioRow>
    );
};
